var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"200px","padding-top":"50px"}},[_vm._v(" "+_vm._s(_vm.$t('home.notFound'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }